import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalphysicalabandoned-card',
  templateUrl: './helpbutton-reports-totalphysicalabandoned-card.component.html',
  styleUrls: ['./helpbutton-reports-totalphysicalabandoned-card.component.scss']
})
export class HelpbuttonReportsTotalphysicalabandonedCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
